import fetch from 'auth/FetchInterceptor'
import {API_BASE_URL} from "../configs/AppConfig";

const defaultService = {}

defaultService.get = function (url, params) {
    return fetch({
        url: url,
        method: 'get',
        params
    })
}

defaultService.post = function (url, data) {
    return fetch({
        url: url,
        method: 'post',
        data: data
    })
}

export default defaultService
